import { CommonRequest, CommonResponse, Method, ServiceName } from 'models/common/RestApi';
import { callApi } from 'utils/ApiUtil';
import { SetupEquipment, SetupEquipmentCondition } from 'models/setup/SetupEquipment';
import { SetupProject, SetupProjectRequest } from 'models/setup/SetupProject';

/**
 * 셋업설비 목록 조회 (default 조회조건)
 * @param condition
 */
export const defaultSetupEquipmentSummary = async (condition?: SetupEquipmentCondition) => {
  const request: CommonRequest = {
    method: Method.GET,
    url: `/v1/setup/default-equipment-summary`,
    serviceName: ServiceName.ELM_BE,
    queryParams: new URLSearchParams({ ...condition }),
  };

  const response: CommonResponse<[]> = await callApi(request);
  return (response.successOrNot === 'Y' ? response.data : null) as SetupEquipmentCondition;
};

/**
 * 셋업설비 목록 조회
 * @param condition
 */
export const findSetupEquipmentSummary = async (condition?: SetupEquipmentCondition) => {
  const request: CommonRequest = {
    method: Method.GET,
    url: `/v1/setup/equipment-summary`,
    serviceName: ServiceName.ELM_BE,
    queryParams: new URLSearchParams({ ...condition }),
  };

  const response: CommonResponse<[]> = await callApi(request);
  return (response.successOrNot === 'Y' ? response.data : []) as SetupEquipment[];
};

/**
 * 샘플일정 목록 조회
 * @param condition
 */
export const findSampleSchedule = async (condition?: SetupEquipmentCondition) => {
  const request: CommonRequest = {
    method: Method.GET,
    url: `/v1/setup/sample-schedule`,
    serviceName: ServiceName.ELM_BE,
    queryParams: new URLSearchParams({ ...condition }),
  };

  const response: CommonResponse<[]> = await callApi(request);
  return (response.successOrNot === 'Y' ? response.data : []) as SetupEquipment[];
};

/**
 * 셋업설비 목록 조회
 * @param condition
 */
export const findSetupEquipment = async (condition?: SetupEquipmentCondition) => {
  const request: CommonRequest = {
    method: Method.GET,
    url: `/v1/setup/equipment`,
    serviceName: ServiceName.ELM_BE,
    queryParams: new URLSearchParams({ ...condition }),
  };

  const response: CommonResponse<[]> = await callApi(request);
  return (response.successOrNot === 'Y' ? response.data : []) as SetupEquipment[];
};

export const saveSetupEquipment = async (setupProjectRequest: SetupProjectRequest | undefined) => {
  const request: CommonRequest = {
    method: Method.POST,
    url: `/v1/setup/equipment`,
    serviceName: ServiceName.ELM_BE,
    bodyParams: setupProjectRequest,
  };
  const response: CommonResponse<string> = await callApi(request);
  return response;
};

/**
 * 셋업설비 등록 가능상태 확인
 * @param elmPrjId
 */
export const checkAvailableSetupEquipments = async (elmPrjId: string) => {
  const request: CommonRequest = {
    method: Method.GET,
    url: `/v1/setup/equipment/check-register`,
    serviceName: ServiceName.ELM_BE,
    queryParams: new URLSearchParams({ elmPrjId: elmPrjId }),
  };

  const response: CommonResponse<boolean> = await callApi(request);
  return response;
};
